import { createI18n } from "vue-i18n";
import uz from "./lang/uz.json"; // O'zbekcha lotincha
import oz from "./lang/oz.json"; // O'zbekcha kirillcha
import { toCyrill } from "~/shared/translate";
import { getItem } from "./shared/localstorage.util";

// Obyekt ichidan chuqur qiymat olish funksiyasi
interface NestedObject {
  [key: string]: any;
}

function getNestedValue(obj: NestedObject, path: string): any {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

export default createI18n({
  locale: getItem("lang") || "oz", // Default til
  fallbackLocale: "oz", // Fallback til
  legacy: false, // Composition API uchun
  messages: {
    uz,
    oz,
  },
  
  missing: (locale, key, instance) => {
    if (locale === "oz") {
      const originalValue = getNestedValue(uz, key)?.loc?.source;
      if (originalValue) {
        return toCyrill(originalValue);
      }
    }
    return key;
  },
});
